/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Box, Flex } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { TiDelete } from 'react-icons/ti';
import { AiFillMinusCircle, AiFillCheckCircle } from 'react-icons/ai';
import { BiBookAdd, BiChevronsUp, BiChevronUp } from 'react-icons/bi';
import { NotificationTypes } from '../../../firebase/firestore/documents/notificationTypes';
import { badgeStatusCSS } from '../Header.styles';

export type NotificationStatusIconProps = {
  notificationType: string;
};

export const NotificationStatusIcon = ({ notificationType }: NotificationStatusIconProps): JSX.Element => {
  const { t } = useTranslation('notification');

  const classNameHandler = () => {
    switch (notificationType) {
      case NotificationTypes.POSITION_INACTIVE_REMINDER_NOTIFICATION:
        return 'inactive';
      case NotificationTypes.I9_REQUESTED:
        return 'requested';
      case NotificationTypes.I9_SUBMISSION:
        return 'submitted';
      case NotificationTypes.I9_RESUBMISSION:
        return 'reSubmitted';
      case NotificationTypes.I9_APPROVED:
        return 'accepted';
      default:
        return 'declined';
    }
  };

  const renderIcon = () => {
    switch (notificationType) {
      case NotificationTypes.POSITION_INACTIVE_REMINDER_NOTIFICATION:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <AiFillMinusCircle />
            {t('statusIcon.inactive')}
          </Flex>
        );
      case NotificationTypes.I9_REQUESTED:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <BiBookAdd />
            {t('statusIcon.i9CheckRequested')}
          </Flex>
        );
      case NotificationTypes.I9_SUBMISSION:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <BiChevronUp />
            {t('statusIcon.i9CheckSubmitted')}
          </Flex>
        );
      case NotificationTypes.I9_RESUBMISSION:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <BiChevronsUp />
            {t('statusIcon.i9CheckReSubmitted')}
          </Flex>
        );
      case NotificationTypes.I9_APPROVED:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <AiFillCheckCircle />
            {t('statusIcon.i9CheckApproved')}
          </Flex>
        );
      default:
        return (
          <Flex alignItems="center" gap="2" justifyContent="center">
            <TiDelete />
            {t('statusIcon.expired')}
          </Flex>
        );
    }
  };

  return (
    <Box
      css={badgeStatusCSS}
      fontSize="xs"
      px={2}
      mx={2}
      textTransform="capitalize"
      lineHeight="1.8"
      className={classNameHandler()}
    >
      {renderIcon()}
    </Box>
  );
};
